import { Component, ErrorInfo, ReactNode } from 'react'
import styled from 'styled-components'

import typeStyle from '../../styles/typeStyle'
import { dispatchRollbarError } from '../../utils/rollbar'

const ComponentError = styled.div`
  ${typeStyle('-ds-font-body-light')}
  padding: 16px;

  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  color: #333;
  background-color: ${({ theme }) => theme.brand.afterglow};
`

type Props = {
  children: ReactNode
  name: string
}

type State = {
  error: Error | null
  errorInfo: ErrorInfo | null
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      error: null,
      errorInfo: null,
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    })
    const { name } = this.props
    dispatchRollbarError(error, {
      componentStack: errorInfo.componentStack,
      boundary: name,
    })
  }

  render(): ReactNode {
    const { children } = this.props
    const { errorInfo, error } = this.state
    if (errorInfo) {
      return (
        <ComponentError>
          <h2>Error in this component tree.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {error && error.toString()}
            <br />
            {errorInfo.componentStack}
          </details>
        </ComponentError>
      )
    }
    return children
  }
}
